import { DatePipe, DecimalPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormatParserService } from 'src/app/services/global-services/format-parser.service';


@Pipe({
  name: 'dynamicFormatPipe',
  standalone: true,
  pure: true
})
export class DynamicFormatPipe implements PipeTransform {

  private readonly datePipe = inject(DatePipe);
  private readonly decimalPipe = inject(DecimalPipe);
  private readonly dateConverter = inject(DateConverterService);
  private readonly formatParser = inject(FormatParserService);

  transform(value: any, type: string, printFormat: string | null = null): any {
    if (value == null) return '';
    const cleanType = type?.trim().toLowerCase() || '';

    switch (cleanType) {
      case 'date':
      case 'daterange':
        return this.datePipe.transform(value, 'dd/MM/yyyy');
      case 'datetime':
        return this.datePipe.transform(value, 'dd/MM/yyyy hh:mm:ss a');
      case 'decimal':
        if (printFormat?.trim()) {
          return this.formatParser.apply(value, printFormat);
        }
        return this.decimalPipe.transform(value, '1.2-2');
      case 'datetimerange':
        {
          const localDate = this.dateConverter.convertUtcToLocalDateFull(value);
          return this.datePipe.transform(localDate, 'dd/MM/yyyy hh:mm:ss a');
        }
      case 'checkbox':
        return value ? 'X' : '';
      default:
        return value;
    }
  }
}
